import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=6406f62f&scoped=true"
import script from "./IconRefresh.vue?vue&type=script&lang=js"
export * from "./IconRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406f62f",
  null
  
)

export default component.exports